import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export function NearbySearchNotice({
  location,
  distanceMiles,
}: {
  location: string;
  distanceMiles: number;
}) {
  const { t } = useTranslation();

  return (
    <div
      data-testid="nearby-search-notice"
      role="status"
      className="mb-4 flex items-start gap-3 rounded-lg border border-primary/20 bg-primary/5 px-4 py-3"
    >
      <MapPin aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
      <p className="text-sm text-foreground">
        {t("search.nearby_results_notice", {
          location,
          distance: distanceMiles,
          defaultValue: "No cars found in {{location}} for these dates. Showing cars within {{distance}} miles.",
        })}
      </p>
    </div>
  );
}